import React, { Component } from 'react';
import PDF from 'react-pdf-js';

import Crop from '../../Crop';
import { getTransformedImage } from '../../imageTransformer';
import Pagination from './Pagination';

class PDFPreview extends Component {
  state = { page: 1, cropURL: false };

  onDocumentComplete = pages => this.setState({ pages });

  onPageComplete = page => this.setState({ page });

  handleFirst = () => this.setState({ page: 1, cropURL: false });

  handlePrevious = () =>
    this.setState({ page: this.state.page - 1, cropURL: false });

  handleNext = () =>
    this.setState({ page: this.state.page + 1, cropURL: false });

  handleLast = () => this.setState({ page: this.state.pages, cropURL: false });

  zoom = () => this.setState(({ zoomedIn }) => ({ zoomedIn: !zoomedIn }));

  toggleCropMode = () => {
    const { pdf } = this.refs;
    const cropURL = this.state.cropURL
      ? false
      : pdf && pdf.canvasParent.childNodes[0].toDataURL();
    this.setState({ cropURL });
  };

  handleCropComplete = crop => {
    const { onCropComplete, onClose } = this.props;
    getTransformedImage(this.state.cropURL, crop, 0, 'test.jpg', true).then(
      img => {
        if (!img) return;
        onCropComplete(img);
        onClose();
      }
    );
  };

  render() {
    const { src, zoomable, croppable, editDisabled } = this.props;
    const { pages, page, cropURL, zoomedIn } = this.state;
    const pagination = pages ? (
      <Pagination
        page={page}
        pages={pages}
        cropURL={cropURL}
        croppable={croppable}
        onFirst={this.handleFirst}
        onPrevious={this.handlePrevious}
        onNext={this.handleNext}
        onLast={this.handleLast}
        editDisabled={editDisabled}
        toggleCropMode={this.toggleCropMode}
      />
    ) : null;

    if (cropURL) {
      return (
        <div>
          {pagination}
          <Crop
            ref="crop"
            src={cropURL}
            onCrop={this.handleCropComplete.bind(this)}
            disabled={editDisabled}
            adjustable
          />
        </div>
      );
    }
    if (zoomable)
      return (
        <div>
          {pagination}
          <div
            style={{
              maxHeight: '75vh',
              overflow: 'auto',
              cursor: zoomedIn ? 'zoom-out' : 'zoom-in'
            }}
            onClick={this.zoom}
          >
            <PDF
              ref="pdf"
              file={src}
              fillWidth={!zoomedIn}
              scale={zoomedIn ? 1.5 : 1}
              onDocumentComplete={this.onDocumentComplete}
              onPageComplete={this.onPageComplete}
              page={page}
            />
          </div>
        </div>
      );
    return (
      <div>
        {pagination}
        <PDF
          ref="pdf"
          scale={1.5}
          file={src}
          onDocumentComplete={this.onDocumentComplete}
          onPageComplete={this.onPageComplete}
          page={page}
        />
      </div>
    );
  }
}

const PDFThumbnail = ({ src, scale, onFileError }) => (
  <PDF
    file={src}
    scale={scale}
    className="pdf-viewer"
    onDocumentError={onFileError}
  />
);

export { PDFThumbnail };
export default PDFPreview;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/PDFPreview/index.js